<template>
  <div>
    <v-dialog
      v-model="pickupVisible"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      @keydown.esc="closePickupDialog"
    >
      <v-card
        tile
      >
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="closePickupDialog"
          >
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>
          <v-toolbar-title>Assistenza {{ assistance.code }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-row v-if="currentAssistance">
            <v-col
              cols="12"
              lg="6"
              md="8"
              sm="8"
              class="offset-lg-3 offset-sm-2 offset-md-2  mt-10"
            >
              <v-card class="mb-6 ghd-border-black">
                <div class="text-center text-large ghd-ITCAvant text-black text-uppercase">
                  Prodotti
                </div>
                <v-card-text>
                  <div
                    v-if="currentAssistance && currentAssistance.products"
                  >
                    <div
                      v-for="product in currentAssistance.products.slice(0,1)"
                      :key="currentAssistance.id+product.id"
                    >
                      <div class="contenitore">
                        <div class="image-container">
                          <img
                            class="image"
                            :src="product.info.item_icon"
                          >
                        </div>

                        <div class="text-container">
                          <div class="font-weight-semibold text-no-wrap ghd-ITCAvant text-black">
                            {{ product.prodotto.nome }}
                          </div>

                          <span
                            class="text-xs text-no-wrap text-black"
                          >
                            Seriale: {{ product.prodotto.seriale }}</span>
                        </div>

                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>

              <v-card class="ghd-border-black">
                <div class="text-center text-large ghd-ITCAvant text-black text-uppercase mb-5">
                  Prenotazione ritiro
                </div>
                <v-card-text>
                  <v-row v-if="currentAssistance.can_store_pickup">
                    <v-form
                      v-if="canBookPickup"
                      ref="formStorePickup"
                      style="width: 100%;"
                    >
                      <v-card class="ghd-border-black mb-5">
                        <v-card-title class="d-flex">
                          <div
                            class="text-center text-medium ghd-ITCAvant text-black text-uppercase mb-5 mt-5"
                          >
                            Inserisci la data e l'indirizzo per il ritiro
                          </div>
                        </v-card-title>

                        <v-card-text style="padding: 0px">
                          <div v-if="ownAddressIsVisible || userData.currier === 'GLS'">
                            <div
                              v-if="userData.currier === 'GLS'"
                              class="text-center text-sm text-black text-uppercase mb-5"
                            >
                              Il servizio di ritiro fuori dal territorio nazionale non è attualmente
                              disponibile, poiché i nostri corrieri operano unicamente sul
                              territorio italiano.
                              Per il servizio di garanzia fuori dal territorio nazionale italiano, è
                              necessario rivolgersi alla sede ghd di riferimento cliccando

                              <a
                                href="https://ukie.help.ghdhair.com/hc/en-gb"
                                target="_blank"
                              >QUI</a>
                            </div>
                            <v-col
                              cols="12"
                            >
                              <v-row>
                                <v-col
                                  cols="12"
                                  lg="4"
                                  md="4"
                                >
                                  <v-menu
                                    ref="menuref"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="sendData.data_choosed"
                                        label="Data prenotazione"
                                        readonly
                                        outlined
                                        dense
                                        v-bind="attrs"
                                        :rules="[validators.required]"
                                        v-on="on"
                                      ></v-text-field>
                                    </template>

                                    <v-date-picker
                                      ref="picker"
                                      v-model="sendData.data_choosed"
                                      :min="new Date().toISOString().substr(0, 10)"
                                      color="primary"
                                      locale="it-IT"
                                      :first-day-of-week="1"
                                      :allowed-dates="allowedDates"
                                      @change="save"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col
                                  cols="12"
                                  lg="4"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="sendData.clientePickup"
                                    label="Nome e cognome"
                                    placeholder="Nome e cognome"
                                    outlined
                                    dense
                                    :rules="[validators.required]"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  lg="4"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="sendData.indirizzoPickup"
                                    label="Via"
                                    placeholder="Via"
                                    outlined
                                    dense
                                    :rules="[validators.required]"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  lg="4"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="sendData.civicoPickup"
                                    label="Civico"
                                    placeholder="Civico"
                                    outlined
                                    dense
                                    :rules="[validators.required]"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  lg="4"
                                  md="4"
                                >
                                  <v-select
                                    v-model="sendData.provinciaPickup"
                                    :items="province"
                                    item-text="label"
                                    item-value="value"
                                    hide-details="auto"
                                    label="Provincia"
                                    outlined
                                    dense
                                    :rules="[validators.required]"
                                  ></v-select>
                                </v-col>
                                <v-col
                                  cols="12"
                                  lg="4"
                                  md="4"
                                >
                                  <v-select
                                    v-model="sendData.localitaPickup"
                                    :items="filterCityByProvince(sendData.provinciaPickup)"
                                    item-text="label"
                                    item-value="value"
                                    hide-details="auto"
                                    label="Citta"
                                    placeholder="Citta"
                                    outlined
                                    dense
                                    :rules="[validators.required]"
                                  ></v-select>
                                </v-col>
                                <v-col
                                  cols="12"
                                  lg="4"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="sendData.capPickup"
                                    label="Cap"
                                    placeholder="Cap"
                                    outlined
                                    dense
                                    :rules="[validators.required]"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  lg="4"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="sendData.phonePickup"
                                    label="Telefono"
                                    placeholder="Telefono"
                                    outlined
                                    dense
                                  />
                                </v-col>
                              </v-row>
                            </v-col>
                          </div>

                          <brt-pudo-list
                            v-else
                            :visible="!ownAddressIsVisible"
                            @point-selected="getSelectedPoint"
                          />

                          <v-col
                            v-if="userData.currier !== 'GLS'"
                            cols="12 p-3 text-center"
                          >
                            <hr>

                            <v-card class="ghd-border-black mt-4">
                              <v-card-text>
                                <p class="text-black text-medium">
                                  {{ textToggleAddressType }}
                                </p>
                                <div class="ml-auto">
                                  <v-btn

                                    color="primary"
                                    small
                                    rounded
                                    @click="toggleOwnAddressIsVisible"
                                  >
                                    {{ labelForButtonAddress }}
                                  </v-btn>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-card-text>
                      </v-card>

                      <div class="text-medium ghd-ITCAvant text-black text-uppercase mb-4">
                        Ricorda di stampare il QrCode ricevuto via mail:
                        <ul style="list-style-type: decimal;">
                          <li>Applica una copia all'esterno del pacco</li>
                          <li>Inserisci una copia all'interno del pacco insieme al prodotto</li>
                        </ul>
                      </div>
                      <v-btn
                        color="primary"
                        large
                        block
                        @click="handleDispatchStorePickup()"
                      >
                        Prenota ritiro
                      </v-btn>
                    </v-form>

                    <v-col
                      v-else
                      class="d-flex flex-column align-center justify-center text-center"
                    >
                      <div class="text-h6">
                        Prenotazioni temporaneamente sospese
                      </div>
                      <div>
                        Il servizio di prenotazione ritiri non è al momento disponibile.
                      </div>
                    </v-col>

                    <dialog-loader :visible="savingPickup" />
                  </v-row>
                  <v-row
                    v-if="currentAssistance && currentAssistance.pickups && currentAssistance.pickups.length"
                    :class="currentAssistance.can_store_pickup ? 'mt-4' : ''"
                  >
                    <v-col
                      v-for="pickup in currentAssistance.pickups"
                      :key="pickup.id"
                      cols="12"
                      lg="6"
                      md="6"
                    >
                      <v-card class="ghd-border-black">
                        <v-card-title
                          v-if="pickup.n_ritiro && pickup.currier == 'GLS'"
                          class="mb-2"
                        >
                          N ritiro: <strong>{{ pickup.full_n_ritiro }}</strong>
                        </v-card-title>
                        <v-card-subtitle
                          v-if="pickup.status_desc"
                        >
                          <div class="d-flex align-items-start">
                            <div class="text-black text-medium">
                              <div>
                                {{ pickup.status_desc }}
                              </div>

                              <small
                                v-if="pickup.n_ritiro"
                                class="text-grey d-block"
                              >
                                <i>Rif: {{ pickup.n_ritiro }}</i>
                              </small>

                              <span
                                v-if="pickup.data_esecuzione_operazione"
                                class="d-block"
                              >
                                – previsto per il {{ pickup.data_esecuzione_operazione }}
                              </span>
                            </div>

                            <div class="ml-auto pl-2">
                              <img
                                :src="require(`@/assets/images/pickup/${pickup.request.isPudo ? 'marker' : 'home'}.png`)"
                                width="30"
                                height="30"
                                :alt="pickup.request.isPudo ? 'Ritiro presso pudo' : 'Ritiro a casa'"
                              />
                            </div>
                          </div>
                        </v-card-subtitle>
                        <v-card-text class="text-black text-medium">
                          <div>
                            <p>{{ pickup.request.clientePickup }}</p>
                            <div v-if="pickup.request.pointNamePickup">
                              <div>
                                Fermopoint selezionato: <strong>{{ pickup.request.pointNamePickup }}</strong>
                              </div>
                              <small
                                class="mb-2"
                                style="color: #999999"
                              >
                                <i>Puoi consegnare presso qualsiasi punto di ritiro BRT. Ti abbiamo
                                  inviato una mail con tutte le informazioni per la tua
                                  spedizione.</i>
                              </small>
                            </div>
                            <p>
                              Indirizzo: {{ pickup.request.indirizzoPickup }},
                              {{ pickup.request.civicoPickup }} {{ pickup.request.capPickup }}
                              {{ pickup.request.localitaPickup }}
                            </p>
                            <p v-if="pickup.expires_at">
                              Spedizione valida fino:
                              <strong>{{ formatDate(new Date(pickup.expires_at), 'd F Y')
                              }}</strong>
                            </p>
                          </div>

                          <v-btn
                            v-if="pickup.streamLabel"
                            color="primary"
                            block
                            small
                            class="mt-4"
                            @click="printPdf(pickup.streamLabel)"
                          >
                            Scarica etichetta BRT
                          </v-btn>

                          <v-btn
                            color="primary"
                            block
                            small
                            class="mt-4"
                            @click="handleDispatchTrackingPickup(pickup)"
                          >
                            Traccia ritiro
                          </v-btn>

<!--                          <v-btn-->
<!--                            v-if="canDeletePickup(pickup)"-->
<!--                            color="primary"-->
<!--                            block-->
<!--                            small-->
<!--                            class="mt-4"-->
<!--                            @click="handleDispatchDeletePickup(pickup)"-->
<!--                          >-->
<!--                            Cancella ritiro-->
<!--                          </v-btn>-->

                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              lg="6"
              md="12"
              sm="12"
              class="offset-3"
            >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <dialog-white
      v-if="isTrackingDialogVisible"
      @turnoff="closeTrackingDialog"
    >
      <template #content>
        <div v-if="trackingData.ritiro && trackingData.ritiro.length">
          <div class="ghd-text-black ghd-ITCAvant text-uppercase text-black ml-6 text-large">
            Dettagli ritiro
          </div>
          <v-card-text>
            <v-data-table
              :headers="headerRitiro"
              :items="trackingData.ritiro"
              hide-default-footer
              disable-sort
            />
          </v-card-text>
        </div>

        <div v-else-if="trackingData.spedizione && trackingData.spedizione.length">
          <div class="ghd-text-black ghd-ITCAvant text-uppercase text-black ml-6 text-large">
            Dettagli spedizione
          </div>
          <v-card-text>
            <v-data-table
              :headers="headerRitiro"
              :items="trackingData.spedizione"
              hide-default-footer
              disable-sort
            />
          </v-card-text>
        </div>

        <div v-else>
          <div class="ghd-text-black ghd-ITCAvant text-uppercase text-black ml-6 text-large">
            Dettagli spedizione
          </div>
          <v-card-text>
            <v-data-table
              :headers="headerRitiroBrt"
              :items="trackingData"
              hide-default-footer
              disable-sort
            />
          </v-card-text>
        </div>
      </template>
    </dialog-white>
  </div>
</template>

<script>
import { mdiClose } from '@mdi/js'

import {
  computed, ref, watch, onMounted,
} from '@vue/composition-api'
import { getUserData, formatDate } from '@core/utils'

import dayjs from 'dayjs'
import { required } from '@core/utils/validation'
import assistanceService from '@/services/assistanceService'
import 'vue2-timepicker/dist/VueTimepicker.css'
import registrationsService from '@/services/registrationsService'
import DialogWhite from '@/views/dialogs/dialogWhite.vue'
import BrtPudoList from '@/views/components/BrtPudoList.vue'
import DialogLoader from '@/views/dialogs/dialogLoader.vue'
import settingsService from '@/services/settingsService'

export default {
  components: {
    DialogLoader,
    BrtPudoList,
    DialogWhite,
  },
  props: {
    pickupVisible: {
      required: true,
      type: Boolean,
    },
    assistance: {
      required: true,
      type: [Object, Array],
    },
  },
  setup(props, { emit }) {
    const {
      fetchSetting,
      getLoading: getSettingsLoading,
      canBook,
    } = settingsService()

    const {
      province,
      comuni,
      generateProvincia,
      generateComune,
      filterCityByProvince,
    } = registrationsService()

    const {
      currentAssistance,
      handleStorePickup,
      handleDeletePickup,
      handleTrackingPickup,
      getAssistance,
      fetchAssistance,
    } = assistanceService()

    const settingsLoading = computed(() => getSettingsLoading())
    const canBookPickup = computed(() => canBook())

    onMounted(() => {
      fetchSetting('booking_enabled', false)
    })

    const menu = ref(false)

    // const picker = ref(null)
    const menuref = ref(null)

    const save = d => {
      menuref.value.save(d)
    }
    const userData = getUserData()
    const formStorePickup = ref(null)
    const trackingData = ref({})
    const isTrackingDialogVisible = ref(false)
    const ownAddressIsVisible = ref(false)
    const selectedPudo = ref(null)
    const savingPickup = ref(false)

    const headerRitiro = ref([
      { text: 'Data', value: 'Data' },
      { text: 'Ora', value: 'Ora' },
      { text: 'Luogo', value: 'Luogo' },
      { text: 'Stato', value: 'Stato' },
    ])

    const decodeBase64 = base64Content => {
      const raw = window
        .atob(base64Content.replace(/_/g, '/').replace(/-/g, '+')) // Compatibilità con URL-safe Base64

      const byteArray = new Uint8Array(new ArrayBuffer(raw.length))
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < raw.length; i++) {
        byteArray[i] = raw.charCodeAt(i)
      }

      return byteArray
    }

    const printPdf = content => {
      try {
        // Decodifica Base64 → Uint8Array
        const byteArray = decodeBase64(content)

        // Crea un Blob dal PDF
        const pdfBlob = new Blob([byteArray], { type: 'application/pdf' })

        // Crea un URL oggetto per il Blob
        const pdfUrl = URL.createObjectURL(pdfBlob)

        // Apri il PDF in una nuova finestra
        const printWindow = window.open(pdfUrl)
        if (printWindow) {
          printWindow.onload = () => {
            printWindow.print()
          }
        }
      } catch (error) {
        console.log(error)
      }
    }

    const headerRitiroBrt = ref([
      { text: 'Data', value: 'data' },
      { text: 'Ora', value: 'ora' },
      { text: 'Descrizione', value: 'descrizione' },
    ])

    const sendData = ref({})

    const resetSendData = () => {
      sendData.value = {
        data_choosed: null,

        // dati per il nuovo indirizzo
        clientePickup: '',
        indirizzoPickup: '',
        civicoPickup: '',
        localitaPickup: '',
        capPickup: '',
        provinciaPickup: '',
        phonePickup: '',
      }
    }

    const labelForButtonAddress = computed(() => (!ownAddressIsVisible.value ? 'Indirizzo manuale' : 'Visualizza punti di ritiro'))
    const textToggleAddressType = computed(() => (!ownAddressIsVisible.value ? 'Preferisci far arrivare il corriere a casa tua?' : 'Preferisci scegliere un punto di ritiro?'))

    generateProvincia()
    generateComune()

    const toggleOwnAddressIsVisible = () => {
      ownAddressIsVisible.value = !ownAddressIsVisible.value
    }

    const getSelectedPoint = point => {
      selectedPudo.value = point

      sendData.value = {
        // dati per il nuovo indirizzo
        clientePickup: userData.fullname,
        indirizzoPickup: selectedPudo.value.street,
        civicoPickup: selectedPudo.value.streetNumber,
        localitaPickup: selectedPudo.value.town,
        capPickup: selectedPudo.value.zipCode,
        provinciaPickup: selectedPudo.value.state,
        phonePickup: userData.telefono,
        pudoId: selectedPudo.value.pudoId,
        pointName: selectedPudo.value.pointName,
      }
    }

    watch(() => props.pickupVisible, newVal => {
      if (newVal) {
        fetchAssistance(props.assistance.code)
      }
    })

    watch(ownAddressIsVisible, newVal => {
      if (newVal) {
        selectedPudo.value = null
        resetSendData()
      }
    })

    // Carica i dati all'avvio del componente

    const tomorrow = computed(() => {
      const today = new Date()
      const nextDay = new Date()
      nextDay.setDate(today.getDate() + 1)

      const year = nextDay.getFullYear()
      const month = String(nextDay.getMonth() + 1).padStart(2, '0') // Ensures two digits
      const day = String(nextDay.getDate()).padStart(2, '0') // Ensures two digits

      return `${year}-${month}-${day}`
    })

    const isWeekend = dateToCheck => {
      const day = (new Date(dateToCheck)).getDay()
      let month = new Date().getMonth() + 1
      month = `0${month}`.slice(-2)
      const today = `${new Date().getFullYear()}-${month}-${new Date().getDate()}`

      return day === 6 || day === 0 || today === dateToCheck// 6=sabato, 0=domenica
    }

    const allowedDates = computed(() => {
      const isAfter5PMAndIsBartolini = new Date().getHours() >= 17 && userData.currier === 'BRT'

      return dateToCheck => !isWeekend(dateToCheck) && ((!isAfter5PMAndIsBartolini) || dateToCheck !== tomorrow.value)
    })

    const refetchData = () => {
      fetchAssistance(props.assistance.code)
    }

    const closePickupDialog = () => {
      emit('update:pickupVisible', false)
    }

    const mappingSendDataForStorePickup = () => {
      const convertedObject = {}
      // eslint-disable-next-line no-restricted-syntax
      for (const key in sendData.value) {
        if (typeof sendData.value[key] === 'object' && sendData.value[key]) {
          // eslint-disable-next-line radix
          convertedObject[key] = parseInt(sendData.value[key].HH)
        } else {
          convertedObject[key] = sendData.value[key]
        }
      }

      return convertedObject
    }

    const handleDispatchStorePickup = () => {
      if (!ownAddressIsVisible.value && !selectedPudo.value && userData.currier === 'BRT') {
        alert('Necessarrio selezionare un punto di interesse')

        return
      }

      if (formStorePickup.value.validate() || selectedPudo.value) {
        sendData.value.ass_code = props.assistance.code
        savingPickup.value = true

        handleStorePickup(mappingSendDataForStorePickup()).then(() => {
          refetchData()
        }).finally(() => {
          savingPickup.value = false
        })
      }
    }

    const handleDispatchDeletePickup = pickup => {
      handleDeletePickup(pickup).then(() => {
        refetchData()
      })
    }

    const closeTrackingDialog = () => {
      isTrackingDialogVisible.value = !isTrackingDialogVisible.value
      trackingData.value = {}
    }

    const handleDispatchTrackingPickup = pickup => {
      // console.log(pickup.currier);
      //
      // return
      handleTrackingPickup(pickup).then(response => {
        isTrackingDialogVisible.value = !isTrackingDialogVisible.value
        trackingData.value = response.data.data
      })
    }

    const canDeletePickup = pickup => {
      const dateBooked = dayjs.unix(pickup.date_booked)
      const createdAt = dayjs(pickup.created_at)

      if (pickup.currier === 'BRT') {
        const isOlderThan7Days = createdAt.isBefore(dayjs().subtract(7, 'day'))
        const isBeforeTomorrow = dateBooked.isBefore(dayjs().add(1, 'day'))

        return !pickup.data_to_excel || (isOlderThan7Days && isBeforeTomorrow)
      }

      if (pickup.currier === 'GLS') {
        return dateBooked.isBefore(dayjs().add(2, 'day'))
      }

      return false
    }

    return {
      menu,
      menuref,
      currentAssistance,
      sendData,
      userData,
      formStorePickup,

      province,
      comuni,
      allowedDates,
      trackingData,
      isTrackingDialogVisible,
      headerRitiro,
      headerRitiroBrt,

      labelForButtonAddress,
      textToggleAddressType,
      ownAddressIsVisible,
      savingPickup,

      settingsLoading,
      canBookPickup,

      formatDate,
      getSelectedPoint,
      printPdf,
      save,
      closePickupDialog,
      canDeletePickup,
      refetchData,
      getAssistance,
      handleDispatchStorePickup,
      filterCityByProvince,
      handleDispatchDeletePickup,
      handleDispatchTrackingPickup,
      closeTrackingDialog,
      toggleOwnAddressIsVisible,
      icons: {
        mdiClose,
      },
      validators: {
        required,
      },
    }
  },
}
</script>

<style lang="scss" scoped>

.contenitore {

  display: flex;

  flex-direction: row;

  flex-wrap: wrap;

  flex-grow: 1;

  align-items: center;

  @media screen and (max-width: 480px) {

  }

  .image-container {

    width: 25%;

    max-width: 110px;

    height: 120px;

    position: relative;

    overflow: hidden;

    @media screen and (max-width: 480px) {
      width: 30%;
    }

    .image {

      position: absolute;

      top: -15px;

      scale: 1.1;

      object-fit: cover;

      @media screen and (max-width: 480px) {
        scale: 1.3;
      }

    }

  }

  .text-container {

    width: 75%;

    @media screen and (max-width: 480px) {
      width: 70%;
    }

  }

}

</style>
